import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledComicPlayer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  max-height: var(--appheight) !important;
  position: relative;
  overflow: hidden;

  background-color: ${Colors.background};

  .player {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    flex: 1;
    height: 100%;

    .control-bar {
      justify-content: space-between;
      align-items: center;

      &.fullscreen {
        border-radius: 5px 5px 0 0;
      }

      .next-page,
      .prev-page {
        &.not-visible {
          visibility: hidden;
        }
      }
      .next-page.highlighted {
        &:not(:hover) {
          animation: zoomIn 0.6s infinite linear;
        }
      }

      .center-buttons {
        display: flex;
        align-items: center;

        .page-counter {
          display: flex;
          align-items: center;
          gap: 3px;
          color: white;
          margin: 0 10px;
        }
      }

      .left-buttons {
        display: flex;
        align-items: center;

        button {
          margin-right: 5px;
        }
      }
    }
  }
  .mask-player {
    // sombra sutil por arriba
    flex: 1;
    height: 0;
    width: 100%;
    position: relative;
    overflow-y: ${({ allowScroll }) => (allowScroll ? 'auto' : 'hidden')};
    overflow-x: hidden;

    .read-mode-page {
      width: 100%;
      position: absolute;
    }
    .play-mode-page {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      .onion-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 30%;
        top: 0;
        left: 0;
      }
      .masked-boxes {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }
    }
    .bubbles-texts {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 101;
      .bubble {
        cursor: not-allowed;
        &.enabled {
          cursor: pointer;
        }
      }
    }

    .player-wrapper {
      flex: 1;
      max-height: 100%;
    }
  }

  ${({ isMobile }) =>
    isMobile &&
    `overflow: unset;
    .control-bar.fullscreen {
      border-radius: 0 !important;
      height: 50px;
      position: absolute;
      bottom: -54px;

      button {
        height: 30px;
      }
    }

    @media (orientation: landscape) {
      .control-bar.fullscreen {
        height: 100%;
        width: 100px;
        right: -100px;
        bottom: 0;
        flex-direction: column;

        > div,
        .score-board {
          flex-direction: column;
          gap: 5px;
        }
      }

    }
  `}

  @keyframes zoomIn {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }
`;
